import mutations from './mutations'
import { notify } from '@/utils/error'
import tables from '@/api/tables'

import { loadItemsBuilder, loadItemBuilder, saveItemBuilder, deleteItemBuilder } from '../crudFactory'
const apiEndpoint = 'tables'

function recursiveOrderUpdate (updates, businessUnitId) {
  return new Promise((resolve, reject) => {
    const currentUpdate = updates[0]
    const remainingUpdates = updates.slice(1)
    tables.setSortOrder({ businessUnitId, tableId: currentUpdate.id, sortOrder: currentUpdate.sort_order })
      .then(() => {
        if (remainingUpdates.length) {
          recursiveOrderUpdate(remainingUpdates, businessUnitId)
        }
        resolve()
      })
      .catch(error => {
        reject(error)
      })
  })
}

export default {
  namespaced: true,

  state: {
    items: {}
  },

  actions: {
    loadItems: loadItemsBuilder({ apiEndpoint }),
    loadItem: loadItemBuilder({ apiEndpoint }),
    saveItem: saveItemBuilder({ apiEndpoint }),
    deleteItem: deleteItemBuilder({ apiEndpoint }),
    updateTablesOrder ({ rootState }, updates) {
      return new Promise((resolve, reject) => {
        const businessUnitId = rootState.businessUnits.currentBusinessUnit.id
        recursiveOrderUpdate(updates, businessUnitId)
          .then(() => {
            resolve()
          })
          .catch(error => {
            notify(error)
            reject(error)
          })
      })
    }
  },

  mutations: {
    ...mutations
  }
}
